import API from '../../../lib/commons/api'

export const useDevelopmentExternalServiceStorageService = () => {
  const setupGitHubConnect = async (secret: string): Promise<void> => {
    const request = {
      secret,
    }
    API.functional.request('POST', `/api/v1/development/github/setup`, request)
  }

  const isGithubConnected = async (): Promise<boolean> => {
    const response = await API.functional.request(
      'GET',
      '/api/v1/development/github/connected'
    )
    return Boolean(response.json.isConnected)
  }

  return {
    setupGitHubConnect,
    isGithubConnected,
  }
}
